var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FundoValidation',{attrs:{"provider_id":29}})
}
var staticRenderFns = []

export { render, staticRenderFns }